import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './app/router'
import { Provider } from 'react-redux'
import { store } from './app/store'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'

const PAYPAL_CLIENT_ID =
  'AQ-UUOEVKl0yMWlskxBoLIA456VvDOC8cWXS7q_YyNihjgWXLns8yaBh0g9UnoT1HUU4FMQy5TkBgnTo'

let container = document.getElementById('app')!
let root = createRoot(container)

root.render(
  <StrictMode>
    <Provider store={store}>
      <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID, currency: 'GBP' }}>
        <RouterProvider router={router} />
      </PayPalScriptProvider>
    </Provider>
  </StrictMode>,
)
